module.exports = __webpack_public_path__ + "img/error.3d862159.png";